import React from 'react';

const items = [
  { icon: '🥘', label: 'Produits frais et locaux' },
  { icon: '👨‍🍳', label: 'Cuisine en direct' },
  { icon: '📋', label: 'Devis gratuit' },
  { icon: '⭐', label: '5/5 sur Google' },
  { icon: '📍', label: 'Tout le Var (83)' },
  { icon: '🎉', label: 'Tous types d\'événements' },
];

const TrustBanner = () => {
  return (
    <section className="py-8 bg-gold/10 border-y border-gold/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-center gap-8">
          {items.map((item, i) => (
            <div key={i} className="flex items-center gap-2">
              <span className="text-2xl">{item.icon}</span>
              <span className="text-charcoal font-medium">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBanner;
